import { render, staticRenderFns } from "./AuthorPageView.vue?vue&type=template&id=fe341f3c&scoped=true"
import script from "./AuthorPageView.vue?vue&type=script&lang=js"
export * from "./AuthorPageView.vue?vue&type=script&lang=js"
import style0 from "./AuthorPageView.vue?vue&type=style&index=0&id=fe341f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe341f3c",
  null
  
)

export default component.exports